/**
 * Extracts up to 2 uppercase initials from a name or email.
 * Falls back to '??' if nothing usable is provided.
 */
export function initialsFromUser(nameOrEmail?: string | null): string {
  if (!nameOrEmail) return '??'
  const parts = nameOrEmail.split(/[\s@]/).filter(Boolean).slice(0, 2)
  const result = parts.map((s) => s[0]?.toUpperCase() || '').join('')
  return result || '??'
}
